module.exports = __webpack_public_path__ + "img/softshell_ventral_labelled.45f367b7.jpg";